module.exports = __webpack_public_path__ + "img/大理国际3.8032b965.png";